<lx-card-container
  *ngIf="premiumActivities?.length || loading()"
  data-qa="premiumActivitiesWithOptions_cardContainer"
  i18n-title
  title="Premium Activities"
  type="premium-activities"
  [loading]="loading()"
>
  <div class="premium-activities-with-options">
    <div class="premium-activities-with-options__alert">
      <lx-message type="alert" color="blue" data-qa="premiumActivitiesWithOptions_alert">
        <ng-container *ngIf="!optionsVisible; else optionVisible" i18n>No premium activities selected, are you sure?</ng-container>
        <ng-template #optionVisible i18n>Please review the Premium activities selection we picked for you to get you started!</ng-template>
      </lx-message>
    </div>
    <div class="extra-card" *ngIf="!optionsVisible">
      <lx-image class="extra-card__image" alt="Premium Activities" [image]="PREMIUM_ACTIVITIES_FALLBACK_IMAGE" [width]="480" [height]="320" />
      <div class="extra-card__content">
        <div class="extra-card__content__text" i18n>Three afternoons a week, step up your summer camp experience!</div>
        <div class="extra-card__content__text" i18n>
          Our <span class="extra-card__content__text--strong">Premium Activities</span> give you access to exclusive excursions, exciting sports, and more...
        </div>
        <lx-button
          (buttonClick)="onLearnMoreClick()"
          [buttonStyle]="'link'"
          data-qa="premiumActivitiesWithOptions_learnMore"
          i18n-text
          text="Learn more"
        ></lx-button>
      </div>
    </div>

    <div *ngIf="optionsVisible" class="premium-activities-with-options__activities">
      <div class="premium-activities-with-options__paragraph" i18n>You can choose a different one for each week of your stay for each week.</div>
      <div class="premium-activities-with-options__paragraph" i18n>
        <lx-button
          (buttonClick)="onLearnMoreClick()"
          [buttonStyle]="'link'"
          data-qa="premiumActivitiesWithOptions_learnMore"
          i18n-text
          text="Find out more"
        ></lx-button>
        about each Activities.
      </div>

      <div class="premium-activities-with-options__counters-container">
        <div *ngFor="let premiumActivity of extendedPremiumActivities; let i = index">
          <lx-card-with-counter
            [weeks]="premiumActivity.units"
            [min]="0"
            [max]="selectedDuration"
            [fallbackImage]="PREMIUM_ACTIVITIES_FALLBACK_IMAGE"
            (weeksChanged)="onWeeksChange($event, premiumActivity.code, premiumActivity.name)"
            [imgSource]="premiumActivity.thumbnailSmall"
            [rightButtonDisabled]="maxWeeksAchieved"
            [title]="premiumActivity.name"
            [description]="premiumActivity.description"
            [price]="premiumActivity.price"
            [endPrice]="premiumActivity.endPrice"
            [discount]="premiumActivity.discountTotalAsPercentage"
            [attr.data-qa]="'premiumActivitiesWithOptions_activity_' + i"
          >
          </lx-card-with-counter>
        </div>
      </div>

      <div class="premium-activities-with-options__activities__footer">
        <div>{{ this.selectedPremiumActivities | lxSelectedPremiumActivities }}</div>
        <div>{{ totalPrice | lxPrice : { currency: currency?.() } }}</div>
      </div>
    </div>

    <div class="premium-activities-with-options">
      <lx-lite-button
        *ngIf="!optionsVisible"
        text="Add"
        i18n-text
        icon="plus"
        (buttonClick)="openOptions()"
        [attr.data-qa]="'premiumActivitiesWithOptions_addButton'"
      ></lx-lite-button>
    </div>
  </div>
</lx-card-container>

<lx-side-panel-gallery
  [visible]="premiumActivitiesDialogVisible"
  (hiddenPanel)="hidePremiumActivitiesDialog()"
  data-qa="premium_activities_sidePanel"
  [fallbackImage]="PREMIUM_ACTIVITIES_FALLBACK_IMAGE"
  [images]="images"
>
  <h4 class="premium-activities-with-options__details__title" i18n>Premium activities in {{ (schoolLocation$ | async)?.schoolName }}</h4>
  <div class="premium-activities-with-options__details__content" *ngFor="let premiumActivity of premiumActivities">
    <h5 class="premium-activities-with-options__details__content__title">{{ premiumActivity?.name }}</h5>
    <p class="premium-activities-with-options__details__content__description">{{ premiumActivity?.description }}</p>
  </div>
</lx-side-panel-gallery>
